import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import ProductDescriptionInfo from "../../components/product/ProductDescriptionInfo";

function ProductModal({ product, show, onHide, prductSizeData }) {

  const onCloseModal = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="product-quickview-modal-wrapper product_card_modal"
      backdrop="static"
    >
      <span className="btn-close" onClick={onCloseModal}></span>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-6 col-sm-12 col-xs-12 product_modal_left">
            <div className="product-large-image-wrapper">
              {product.ImagePath && (
                <div className="single-image">
                  <img
                    src={process.env.REact_APP_IMG_URL + product.ImagePath}
                    className="img-fluid"
                    alt="Product"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12 product_modal_right">
            <ProductDescriptionInfo
              product={product}
              shortDescription="false"
              showBottomContent={false}
              sizeData={prductSizeData}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

ProductModal.propTypes = {
  onHide: PropTypes.func,
  product: PropTypes.shape({}),
  show: PropTypes.bool,
};

export default ProductModal;
